import { i18n } from "@/config/i18n";
import { MONTHLY_DATA, MONTH_LABELS, YTD_DATA } from "@/data/performance";

export default {
  name: 'Performance',
  data() {
    return {
      tooltip: null,
    };
  },
  computed: {
    ytd() { return YTD_DATA; },

    bestMonth() {
      const best = MONTHLY_DATA.reduce((a, b) => (b.v3 > a.v3 ? b : a));
      const locale = i18n.global.locale.value || 'vi';
      const labels = MONTH_LABELS[locale] || MONTH_LABELS['vi'];
      return { label: labels[MONTHLY_DATA.indexOf(best)], v1: best.v1, v3: best.v3 };
    },

    perfRows() {
      const locale = i18n.global.locale.value || 'vi';
      const labels = MONTH_LABELS[locale] || MONTH_LABELS['vi'];
      const rows = MONTHLY_DATA.map((row, i) => ({
        month:     labels[i],
        v1:        '+' + row.v1 + '%',
        v3:        '+' + row.v3 + '%',
        market:    row.market + '%',
        marketNeg: row.market < 0,
        highlight: false,
      }));
      rows.push({
        month:     'YTD 2026',
        v1:        '+' + YTD_DATA.v1 + '%',
        v3:        '+' + YTD_DATA.v3 + '%',
        market:    '~' + YTD_DATA.market + '%',
        marketNeg: false,
        highlight: true,
      });
      return rows;
    },

    chart() {
      const locale = i18n.global.locale.value || 'vi';
      const labels = MONTH_LABELS[locale] || MONTH_LABELS['vi'];
      const svgW = 640, svgH = 260, padL = 36, padR = 8, padT = 28, padB = 40;
      const chartW = svgW - padL - padR;
      const chartH = svgH - padT - padB;

      const allVals  = MONTHLY_DATA.flatMap(r => [r.v1, r.v3, r.market]);
      const scaleMax = Math.ceil(Math.max(...allVals) * 1.12 / 10) * 10;
      const dataMin  = Math.min(...allVals);
      const scaleMin = dataMin < 0 ? Math.floor(dataMin * 1.5 / 5) * 5 : 0;
      const range    = scaleMax - scaleMin;

      const toY   = val => padT + ((scaleMax - val) / range) * chartH;
      const zeroY = toY(0);
      const rectY = val => val >= 0 ? toY(val) : zeroY;
      const rectH = val => Math.max(3, Math.abs(val / range) * chartH);

      const step = scaleMax > 30 ? 10 : 5;
      const guides = [];
      for (let v = scaleMin; v <= scaleMax; v += step) guides.push({ val: v, y: toY(v) });

      const n = MONTHLY_DATA.length;
      const groupW = (svgW - padL - padR) / n;
      const barW   = Math.floor(groupW * 0.22);
      const gap    = Math.floor(barW * 0.25);
      const totalBarsW = barW * 3 + gap * 2;

      const groups = MONTHLY_DATA.map((row, i) => {
        const gx     = padL + i * groupW;
        const startX = gx + (groupW - totalBarsW) / 2;
        const cx     = gx + groupW / 2;
        const v1X = startX, v3X = startX + barW + gap, mktX = startX + (barW + gap) * 2;
        return {
          label: labels[i], cx,
          v1X, v1Y: rectY(row.v1), v1H: rectH(row.v1), v1Val: row.v1, v1LabelY: rectY(row.v1) - 4,
          v3X, v3Y: rectY(row.v3), v3H: rectH(row.v3), v3Val: row.v3, v3LabelY: rectY(row.v3) - 4,
          mktX, mktY: rectY(row.market), mktH: rectH(row.market), mktVal: row.market,
          mktLabelY: row.market >= 0 ? rectY(row.market) - 4 : zeroY + rectH(row.market) + 11,
          isNeg: row.market < 0,
          labelY: svgH - padB + 14,
        };
      });

      return { svgW, svgH, padL, padR, padT, padB, zeroY, guides, groups, barW, yMax: scaleMax };
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  methods: {
    showTip(event, label, team, val, color) {
      const svg = event.currentTarget.closest('svg');
      const svgRect = svg.getBoundingClientRect();
      const rect = event.currentTarget.getBoundingClientRect();
      this.tooltip = {
        x: rect.left + rect.width / 2 - svgRect.left,
        y: rect.top - svgRect.top - 8,
        label, team, val, color,
      };
    },
  },
};
